import { defineComponent } from 'vue';
import { mapState, mapGetters } from 'vuex';

import SVGLogoPulinetFull from '@/assets/img/logo/logo-pulinet-full.svg';
import SVGLogoPulinetSmall from '@/assets/img/logo/logo-pulinet-small.svg';
import { BackOfficePermissionRoleClaim, UserProfileDTO } from '@/../client-generator/generated-clients/user';

import menuItems from './menu-items';

export default defineComponent({
  name: 'TheSidebar',

  components: {
    SVGLogoPulinetFull,
    SVGLogoPulinetSmall,
  },

  computed: {
    ...mapState(['profile']),
    ...mapState({
      show: 'sidebarShow',
      minimize: 'sidebarMinimize',
    }),
    ...mapGetters(['checkUserRoles', 'checkBackOfficeSubRoles']),

    showTickets(): boolean {
      return this.$route.query.hideTickets !== 'true';
    },

    loggedIn(): boolean {
      return !!(this as any).profile;
    },

    filteredMenuItems(): typeof menuItems {
      const self = this as any;
      return menuItems.filter(
        (menuItem) =>
          self.checkUserRoles(menuItem.allowedRoles as string[]) ||
          self.checkBackOfficeSubRoles(menuItem.allowedBackOfficeSubRoles)
      );
    },
  },
});
